import Image from 'next/image';
import Link from 'next/link';
import Head from "next/head";
import { motion } from 'framer-motion';

const cardVariants = {
    hidden: { scale: 0.95, opacity: 0 },
    visible: { scale: 1, opacity: 1 }
};

export default function Webdesign() {
    const service = {
        title: 'Webdesign',
        details: ['Konzeption', 'Grafik-Design', 'Content', 'Programmierung', 'Front End Entwicklung', 'User Experience', 'Responsive', 'Intranet/Extranet', 'Relaunch'],
        imgSrc: '/serviceImages/pexels-davide-baraldi-11813187.jpg'
    };
    const websites = [
        {
            title: 'AuraColor',
            details: ['NextJs', 'Vercel', 'Blog'],
            imgSrc: '/auracolor.png',
            info: 'Info zu Website 1'
        },
        {
            title: 'deinseoexpert',
            details: ['NextJs', 'Contentful (CMS)', 'Blog'],
            imgSrc: '/deinseoexpertde.png',
            info: 'Info zu Website 2'
        },
        // Fügen Sie hier weitere Websites hinzu...
    ];

    const midIndex = Math.ceil(service.details.length / 2);
    const detailsFirstHalf = service.details.slice(0, midIndex);
    const detailsSecondHalf = service.details.slice(midIndex);

    return (
        <div className="flex flex-col bg-gray-100 p-6 rounded-md shadow-lg">
            <Head>
                <title>Webdesign | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Erfahren Sie mehr über unsere Webdesign-Dienstleistungen. Unsere SEO-Agentur bietet professionelle SEO-Lösungen und kompetente Beratung. Besuchen Sie unsere Website, um Expertenwissen für Ihren SEO-Erfolg zu erhalten."
                />
            </Head>
            <div className="flex flex-col md:flex-row mb-4">
                <div className="relative h-64 md:h-auto md:w-1/2 mb-4 md:mb-0">
                    <Image
                        src={service.imgSrc}
                        alt={service.title}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        className="rounded-md"
                    />
                    <h1 className="absolute bottom-0 left-0 p-4 text-xl md:text-2xl font-bold text-white bg-black bg-opacity-40">{service.title}</h1>
                </div>
                <div className="md:w-1/2 flex flex-col md:flex-row md:justify-center md:items-center md:pl-8">
                    <ul className="list-disc list-inside flex-1">
                        {detailsFirstHalf.map((detail, index) => (
                            <li key={index} className="mb-2">{detail}</li>
                        ))}
                    </ul>
                    <ul className="list-disc list-inside flex-1">
                        {detailsSecondHalf.map((detail, index) => (
                            <li key={index} className="mb-2">{detail}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="mt-4 text-gray-600 p-6 bg-white rounded-md shadow-lg">
                <p className="mb-4">
                    Als Webdesign-Experte verstehe ich die Bedeutung einer gut gestalteten und funktionalen Website für den Erfolg meines Unternehmens. Meine Dienstleistungen im Bereich Webdesign umfassen eine Vielzahl von Aspekten, die mir helfen, meine Online-Präsenz zu optimieren und ein beeindruckendes digitales Erlebnis für meine Kunden zu schaffen.
                    Ich arbeite eng mit meinen Kunden zusammen, um ihre spezifischen Anforderungen und Ziele zu verstehen. Ich setze moderne Designprinzipien ein, um eine ästhetisch ansprechende und benutzerfreundliche Website zu entwickeln, die meine Marke optimal repräsentiert. Von der Konzeption über die individuelle Programmierung bis hin zum individuellen Design setze ich auf maßgeschneiderte Lösungen, die auf meine spezifischen Anforderungen zugeschnitten sind. Meine Dienstleistungen umfassen auch die Schaffung digitaler Einkaufserlebnisse, funktionelle Erweiterungen wie Konfiguratoren und die Integration von Zahlungs- und Logistiklösungen für einen reibungslosen Einkaufsprozess.
                </p>

                <p className="mb-4">
                    Ich bin stolz auf meine Arbeit und kann Ihnen Fallstudien, Beispiele meiner bisherigen Arbeiten und Erfahrungsberichte zufriedener Kunden präsentieren. Ich glaube, dass diese Informationen Ihnen einen Einblick in meine Fähigkeiten und Erfolge geben können und Ihnen dabei helfen, eine fundierte Entscheidung über meine Dienstleistungen zu treffen. Wenn Sie weitere Informationen benötigen oder Fragen haben, zögern Sie nicht, mich zu kontaktieren. Ich freue mich darauf, mit Ihnen zusammenzuarbeiten und Ihre Webdesign-Bedürfnisse zu erfüllen. Kontaktieren Sie mich noch heute, um mehr über meine Webdesign-Dienstleistungen zu erfahren und wie ich Ihnen helfen kann, eine herausragende Online-Präsenz aufzubauen.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                {websites.map((website, index) => (
                    <motion.div
                        key={index}
                        className="bg-white rounded-md shadow-lg overflow-hidden"
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                    >
                        <div className="relative h-64">
                            <Image
                                src={website.imgSrc}
                                alt={website.title}
                                layout="fill"
                                objectFit="cover"
                                objectPosition="center"
                            />
                            <h2 className="absolute bottom-0 left-0 p-4 text-xl md:text-2xl font-bold text-white bg-black bg-opacity-40">{website.title}</h2>
                        </div>
                        <div className="p-4">
                            <ul className="list-disc list-inside">
                                {website.details.map((detail, index) => (
                                    <li key={index} className="mb-2">{detail}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="bg-gray-100 p-4 text-sm text-gray-600">
                            <p>{website.info}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
